export default __webpack_public_path__ + "static/banner6-3565558c29bd1e74664a6fb9a44546c4.png";